module.exports = __webpack_public_path__ + "img/presentation04.14baf597.jpg";